export enum EColor {
  Gray = '#7F94A1',
  Gray2 = '#BEC8CF',
  Gray3 = '#DEE2E6',
  Green = '#21BE6B',
  Green2 = '#61CC85',
  Green3 = '#A1E0B1',
  Green4 = '#DCF3E0',
  Red = '#F36564',
  Blue = '#00A7F6',
  Blue2 = '#46C0F9',
  Blue3 = '#CAE1F1',
  Yellow = '#FFDF76',
  Yellow2 = '#E3BE44',
}

export enum EColorRGB {
  Green = '33, 190, 107',
}